import { apiBookingManager } from "@/services/api-booking-manager";
import { AxiosError } from "axios";
import { createToast } from "vercel-toast";
import {
  CreateBookingApiParams,
  CreateBookingApiResponse,
} from "./create-booking.types";

const validateToast = (data: CreateBookingApiResponse) => {
  if (data?.success_list?.length) {
    createToast(data.success_list[0].data.message, {
      type: "success",
      timeout: 2000,
    });
  }
  if (data?.failed_list && data?.failed_list[0]) {
    createToast(data?.failed_list[0]?.error.details[0].message, {
      type: "error",
      timeout: 4000,
    });
  }
};

export const CreateBookingApi = async (params: CreateBookingApiParams) => {
  try {
    const bookingDate = new Date(params.data.start_date);
    const formattedDate = `${bookingDate.getUTCFullYear()}-${String(bookingDate.getUTCMonth() + 1).padStart(2, "0")}-${String(bookingDate.getUTCDate()).padStart(2, "0")}`;
    const dataFormatted = {
      private_office_id: params.data.private_room.id,
      type: 6,
      on_demand: false,
      company_id: params.data.company.id,
      app_type: 3,
      notes: "",
      package: params.data.package.id,
      bookings: [
        {
          booking_start: `${formattedDate} 00:00:00`,
          months_quantity: Number(params.data.months),
          users_quantity: 1,
          payout_rate_percentual: Number(params.data.take),
          credits: Number(params.data.credits),
        },
      ],
    };

    const { data } = await apiBookingManager.post<CreateBookingApiResponse>(
      `/bookings/privateoffice`,
      dataFormatted,
    );

    validateToast(data);

    return {
      data: data,
    };
  } catch (err) {
    const error = err as AxiosError;

    validateToast(error.response?.data as CreateBookingApiResponse);

    return {
      data: error?.response?.data as CreateBookingApiResponse,
    };
  }
};
